export default __webpack_public_path__ + "static/media/chest-purple-closed.0fa647c2.png";